export const PHONE_AUTH_REQUEST = 'PHONE_AUTH_REQUEST';
export const PHONE_AUTH_SUCCESS = 'PHONE_AUTH_SUCCESS';
export const PHONE_AUTH_FAILED = 'PHONE_AUTH_FAILED';
export const PHONE_AUTH_CLEAN = 'PHONE_AUTH_CLEAN';